import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DestructiveButton, SecondaryButton } from 'DesignSystem/Buttons';
import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import { enableView } from 'EditorOverlay/EditorOverlayActions';
import { unwrapRequestSignaturePopups } from 'actions';
import { declineDocumentShare } from 'Popups/RequestSignaturePopupWrapper/RequestSignatureActions';
import styles from '../../sass/main.scss';

const defaultModalStyle = {
  overlay: {
    alignItems: 'center',
    background: styles.modalBackgroundColor,
    display: 'flex',
    justifyContent: 'center',
    zIndex: styles.modalZIndex,
  },
  content: {
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    bottom: 'unset',
    display: 'flex',
    justifyContent: 'center',
    left: 'unset',
    margin: 0,
    overflow: 'visible',
    position: 'relative',
    right: 'unset',
    top: 'unset',
  },
};

class SignatureDeclineModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isDeclineDisabled: false,
      isDeclineError: false,
    };

    this.formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);
    this.declineSignature = this.declineSignature.bind(this);
    this.onDeclineClick = this.onDeclineClick.bind(this);
    this.showDeclineError = this.showDeclineError.bind(this);
    this.onConfirmDecline = this.onConfirmDecline.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onDeclineClick() {
    this.setState(
      {
        isDeclineDisabled: true,
        isDeclineError: false,
      },
      this.declineSignature,
    );
  }

  onCancel() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.props.closeModal();
  }

  onConfirmDecline() {
    if (this.props.isFreewrite) {
      // Remove request signature popups
      this.props.unwrapRequestSignaturePopups();
      // Replace existing toolbar with decline toolbar
      document.getElementById('new_request_toolbar')
        .remove();

      // Save session state and close modal
      this.props.enableView();
    }
    this.props.closeModal();
  }

  showDeclineError() {
    this.setState({
      isDeclineDisabled: false,
      isDeclineError: true,
    });
  }

  async declineSignature() {
    this.props.trackDeclineAction();
    await this.props.declineDocumentShare(
      this.props.shareKey,
      this.onConfirmDecline,
      this.showDeclineError,
    );
    if (this.props.onConfirmDecline) {
      this.props.onConfirmDecline();
    }
  }

  render() {
    const { isOpen } = this.props;
    return (
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={this.onCancel}
        shouldCloseOnOverlayClick
        style={defaultModalStyle}
      >
        <div className="decline-signature-modal-box">
          <button
            className="decline-signature-close-icon"
            onClick={this.onCancel}
          />
          {this.state.isDeclineError && (
            <div className="terms-of-service-error-banner">
              <b>Please try again later.&nbsp;</b>
              We weren&#39;t able to decline signing this document.
            </div>
          )}
          <div>
            <h4>Decline signing this document?</h4>
            <p>
              You won&#39;t be able to view or edit this document.
              <br />
              The sender will be notified.
            </p>
          </div>
          <div className="decline-signature-button-container">
            <SecondaryButton
              onClick={this.onCancel}
            >
              Cancel
            </SecondaryButton>
            <DestructiveButton
              disabled={this.state.isDeclineDisabled}
              onClick={this.onDeclineClick}
            >
              Decline
            </DestructiveButton>
          </div>
        </div>
      </Modal>
    );
  }
}

SignatureDeclineModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  declineDocumentShare: PropTypes.func.isRequired,
  enableView: PropTypes.func.isRequired,
  isFreewrite: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirmDecline: PropTypes.func,
  shareKey: PropTypes.string.isRequired,
  trackDeclineAction: PropTypes.func.isRequired,
  unwrapRequestSignaturePopups: PropTypes.func.isRequired,
};

SignatureDeclineModal.defaultProps = {
  isFreewrite: false,
  onCancel: null,
  onConfirmDecline: null,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  enableView,
  unwrapRequestSignaturePopups,
  declineDocumentShare,
}, dispatch);

export default connect(null, mapDispatchToProps)(SignatureDeclineModal);



// WEBPACK FOOTER //
// ./src-react/SignatureDeclineButton/SignatureDeclineModal.jsx